import axios from 'axios'

// 开发环境通过 VUE_APP_API_BASE 指向后端（如 http://localhost:8080）
// 生产构建（npm run build）时不设置，使用同源相对路径，由 nginx 反向代理到后端
const api = axios.create({
  baseURL: process.env.VUE_APP_API_BASE || '',
  timeout: 10000
})

// Request interceptor
api.interceptors.request.use(config => {
  // 会员接口使用会员 token，管理端接口使用管理员 token
  if (config.url && config.url.startsWith('/api/member/')) {
    const token = localStorage.getItem('member_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
  } else {
    const token = localStorage.getItem('admin_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
  }
  return config
})

// Response interceptor
api.interceptors.response.use(
  response => response.data,
  error => {
    console.error('API Error:', error)
    return Promise.reject(error)
  }
)

export default api
